import { Link } from 'react-router-dom';

interface Direction {
  icon: string;
  title: string;
  desc: string;
  to?: string;
  linkLabel?: string;
}

const directions: Direction[] = [
  {
    icon: 'ri-hand-coin-line',
    title: 'Продажи и переговоры',
    desc: 'Продажи, переговоры, выявление потребностей, работа с возражениями, телефонные продажи, переписка и работа с клиентами.',
    to: '/prodazhi-i-peregovory',
    linkLabel: 'Хаб «Продажи и переговоры»',
  },
  {
    icon: 'ri-vip-crown-line',
    title: 'Управленческие компетенции',
    desc: 'Лидерство, делегирование, постановка задач, обратная связь, мотивация, управление конфликтами и изменениями.',
    to: '/menedzhment-i-liderstvo',
    linkLabel: 'Хаб «Менеджмент и лидерство»',
  },
  {
    icon: 'ri-emotion-line',
    title: 'Soft Skills',
    desc: 'Коммуникация, эмоциональный интеллект, командное взаимодействие и другие гибкие навыки.',
    to: '/enciklopediya-korporativnogo-obucheniya/razvitie-soft-skills',
    linkLabel: 'Развитие Soft Skills',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: 'Клиентский сервис',
    desc: 'Навыки коммуникации с клиентами, работа со сложными ситуациями и повышение качества клиентского взаимодействия.',
    to: '/prodazhi-i-peregovory/trening-po-rabote-s-klientami',
    linkLabel: 'Работа с клиентами',
  },
  {
    icon: 'ri-briefcase-line',
    title: 'Профессиональные компетенции',
    desc: 'Развитие конкретных навыков, необходимых сотрудникам для выполнения рабочих функций.',
  },
];

export default function CompetencyDirections() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Какие компетенции можно развивать
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-14 leading-relaxed">
          Направления развития определяются тем, какие компетенции сотрудников напрямую влияют на результаты бизнеса.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {directions.map((d, i) => (
            <div key={i} className="bg-white rounded-xl border border-gray-200 p-5 md:p-6 hover:border-teal-300 transition-colors group flex flex-col">
              <div className="w-11 h-11 bg-teal-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-teal-200 transition-colors">
                <i className={`${d.icon} text-xl text-teal-700`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{d.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed mb-4 flex-grow">{d.desc}</p>
              {d.to ? (
                <Link to={d.to} className="inline-flex items-center gap-1.5 text-sm font-semibold text-teal-600 hover:text-teal-700 transition-colors cursor-pointer mt-auto">
                  {d.linkLabel}
                  <i className="ri-arrow-right-line"></i>
                </Link>
              ) : (
                <span className="text-sm text-gray-400 mt-auto">Обсуждается индивидуально</span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}